<div class="dialog-box">
  <p class="modal-title">Documents</p>
  <p class="formats-info">
    <span class="title">These are the documents associated with this item</span><br/>
    <span class="formats-allowed">
      Formats allowed: <span class="format-list">pdf, jpg, xls</span>
    </span>
  </p>

  <div class="document-row" *ngFor="let doc of documents">
    <div class="doc-checkbox" [matTooltip]="shouldShowTooltip(doc.name) ? doc.name : ''">
      <span class="doc-name">
        <span class="doc-name-truncate">{{ getTruncatedName(doc.name) }}</span>
        <span class="doc-ext">{{ getFileExtension(doc.name) }}</span>
      </span>
    </div>

    <button mat-icon-button class="view-icon" (click)="viewDocument(doc)">
      <mat-icon>visibility</mat-icon>
    </button>
  </div>

  <div class="modal-actions">
    <input
      type="file"
      #globalFileInput
      accept=".pdf,.jpg,.jpeg,.xls,.xlsx"
      style="display: none"
      (change)="handleFileUpload($event)"
    />
    <button class="primary-button" (click)="handleAddDocumentClick(globalFileInput)">
      Add new document
    </button>
    <button class="cancel-button" (click)="close()">Cancel</button>
  </div>
</div>
